export default __webpack_public_path__ + "static/media/img_chart_grade_D0.20054da1aca6b8adcce7002e598009e9.svg";